import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <MediaSection />
        <CarouselSection />
        <RankingSection />
        <ContactSection />
        <IndexSection />
        <CommentsSection />
        <FaqSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <AboutSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}